import e from "../managers/braze-instance.js";
import re from "./feed-provider-factory.js";
export function requestFeedRefresh() {
  if (e.rr()) return re.er().xs();
}
